<div class="pagination-container">
  <nav class="pagination-navbar">
    <ul class="pagination-ul">
      <div class="text">
        {{ "SHOWING_PAGE" | translate }} {{ (currentPage - 1) * pageSize + 1 }}
        {{ "SHOWING_TO" | translate }} {{ getEndResult() }}
        {{ "SHOWING_OF" | translate }} {{ numberOfDevices }}
        {{ "SHOWING_RESULTS" | translate }}
      </div>

      <div class="pagination-li">
        <div class="first" (click)="changePage(1)">
          <li>{{ "FIRST_PAGE" | translate }}</li>
        </div>

        <div class="page-icon" (click)="changePage(currentPage - 1)">
          <li>
            <a
              ><img alt="<" src="assets/core/pagination/chevron-left-small.svg"
            /></a>
          </li>
        </div>

        <div
          class="page-icon"
          *ngFor="let page of getPagesToShow()"
          (click)="changePage(page)"
        >
          <li [ngClass]="{ selected: page === currentPage }">
            <a
              ><span>{{ page }}</span></a
            >
          </li>
        </div>

        <div class="page-icon" (click)="changePage(currentPage + 1)">
          <li>
            <a
              ><img
                alt=">"
                src="assets/core/pagination/chevron-right-small.svg"
            /></a>
          </li>
        </div>

        <div class="last" (click)="changePage(lastPageSize)">
          <li>{{ "LAST_PAGE" | translate }}</li>
        </div>
      </div>
    </ul>
  </nav>
</div>
